import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ImagilityBaseResponse } from 'app-models';
import { map, pluck } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MasterListTableService {

  constructor(private httpClient: HttpClient) { }

  getMasterListData(pageFormId, companyId, payload) {
    return this.httpClient.post(`/vd/formBuilder/company/${companyId}/pageForm/${pageFormId}/formsData`, payload).pipe(
      pluck('data'), map((data: any) => {
        return data;
      })
    );
  } //

  getBeneProfileMasterListData(moduleId: number, pageFormId: number, companyId: number, payload) {
    return this.httpClient
      .post(`/vd/formBuilder/module/${moduleId}/pageForm/${pageFormId}/company/${companyId}/masterList/list`, payload)
      .pipe(
        pluck('data'), map((data: any) => {
          return data;
        })
      );
  }

  moveSelectedListItems(payload) {
    return this.httpClient.post(`/vd/fb/save/talentAcq/list`, payload);
 }

  async fetchOptionsFromAPI() {
    const response = await this.httpClient.get('your-api-endpoint-here').toPromise();
    return response as any[];
  }

  deleteMasterListData(payload) {
    return this.httpClient.post(`/vd/formBuilder/formdata/genericdelete`, payload).pipe(
      map((response: ImagilityBaseResponse) => {
        return response;
      })
    );
  }
  postCustomAction(payload, uniquekey) {
    return this.httpClient.post(`/vd/formBuilder/formdata/genericaction/${uniquekey}`, payload).pipe(
      map((response: ImagilityBaseResponse) => {
        return response;
      })
    );
  }

}
